/*
 * Copyright (c) 2023 - 2026. Bluemate B.V.
 */
import './style/reverseCharge.scss';

import React, {FocusEventHandler} from 'react';

import {useTranslation} from 'react-i18next';

import {ChangeFunction, ErrorType, Loader} from '@dvrd/dvr-controls';

import {BluemateCountrySelect, BluemateDialog, BluemateInput} from '../controls';

import classNames from 'classnames';

interface Props {
    onChangeVatNumber: ChangeFunction<string>;
    onChangeCountry: ChangeFunction<string>;
    onSubmit: VoidFunction;
    onClose: VoidFunction;
    onResetError: FocusEventHandler;
    error: ErrorType;
    vatNumber: string;
    country: string;
    active: boolean;
    loading: boolean;
}

export default function ReverseCharge(props: Props) {
    const {t} = useTranslation();
    const {
        error,
        onResetError,
        loading,
        onChangeCountry,
        onChangeVatNumber,
        vatNumber,
        country,
        onClose,
        onSubmit,
        active
    } = props;

    return (
        <BluemateDialog
            active={active}
            onClose={onClose}
            title={t('reverseCharge.title', 'BTW verleggen')}
            className='reverse-charge-dialog'
            width='40rem'
            onConfirm={onSubmit}
            confirmLabel={t('reverseCharge.submit', 'BTW verleggen')}
            cancelLabel={t('reverseCharge.cancel', 'Annuleren')}
            cancelVariant='tertiary'
            loading={loading}
        >
            <Loader active={loading} />
            <p className='description'>
                {t(
                    'reverseCharge.description',
                    'Voor het verleggen van de BTW is het vereist dat er een juist BTW nummer van de klant op de factuur geplaatst wordt. Controleer hieronder het BTW nummer en het land van de klant voordat de BTW verlegd wordt. De huidige factuur wordt gecrediteerd en er zal een nieuwe (verlegde) factuur aangemaakt worden.'
                )}
            </p>
            <div className='fields'>
                <BluemateInput
                    onChange={onChangeVatNumber}
                    value={vatNumber}
                    label={t('reverseCharge.vatNumber', 'BTW nummer *')}
                    onFocus={onResetError}
                    shape='rounded'
                    uniformFont
                />
                <BluemateCountrySelect onChange={onChangeCountry} value={country} />
            </div>
            <label className={classNames('error', error !== null && 'visible')}>
                {error ?? t('reverseCharge.error', 'Fout')}
            </label>
        </BluemateDialog>
    );
}
